import { gql } from '@apollo/client';

export const GET_TRAFFICKING_FILTER_CONFIG = gql`
  query GET_TRAFFICKING_FILTER_CONFIG {
    getTraffickingFilterConfig {
      id
      label
      type
      category
      subCategory
      optionSource
      staticOptions {
        value
        label
      }
      isSearchable
      isBoolean
      isMoney
      multiOptionalLabel
      rangeConfig {
        minPossibleValue
        maxPossibleValue
        isPercentageValue
        helperText
        displayMultiplier
      }
      comparisonConfig {
        hasUnitSelector
        unitOptions
        max
        min
        type
      }
      includeExclude {
        includeKey
        excludeKey
      }
      applicableTabs
      applicableQueries
      operators
      valuePrefix
      valueSuffix
      valueDecimals
      inputType
    }
  }
`;
